if(!global["_scope"]) global["_scope"] = {};
module.exports = global["_scope"]["Appointment"] = require("-!/builds/dev-public/WebApi/node_modules/es3ify-loader/index.js!/builds/dev-public/WebApi/node_modules/imports-loader/index.js?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!/builds/dev-public/WebApi/node_modules/babel-loader/lib/index.js!./Appointment.js");


/*****************
 ** WEBPACK FOOTER
 ** ./~/expose-loader?_scope.Appointment!./application/components/core/Appointment.js
 ** module id = 186
 ** module chunks = 1
 **/